
// Color options with hex codes for collections and tags
export const colorOptions = [
  { name: "Red", value: "#FF314E" },
  { name: "Orange", value: "#EF724A" },
  { name: "Yellow", value: "#F4CD06" },
  { name: "Green", value: "#2FE161" },
  { name: "Teal", value: "#24EDF1" },
  { name: "Blue", value: "#3CBEFF" },
  { name: "Indigo", value: "#0073FF" },
  { name: "Purple", value: "#8052F5" },
  { name: "Raspberry", value: "#CD17CE" },
  { name: "Magenta", value: "#FF00A4" },
];
